import { typoGraphy } from '../../../stylesheets';

export const setTextTypography = ({ size = 'plg' }) => typoGraphy[size] || {};
